/**
 * Generic loading skeleton for in-flight widget queries.
 * Matches the visual footprint of KPI / chart tiles so layout doesn't
 * shift when data arrives.
 */
export interface SkeletonProps {
  height?: number;
  label?: string;
}

export default function Skeleton(props: SkeletonProps) {
  const { height = 140, label } = props;
  return (
    <div
      aria-busy="true"
      role="status"
      style={{
        background:
          "linear-gradient(90deg, var(--bg-card) 0%, var(--border-subtle) 50%, var(--bg-card) 100%)",
        backgroundSize: "200% 100%",
        animation: "meridian-skeleton 1.4s ease-in-out infinite",
        border: "1px solid var(--border-subtle)",
        borderRadius: 12,
        height,
        display: "grid",
        placeItems: "center",
        color: "var(--text-muted)",
        fontSize: 12,
      }}
    >
      <style>{`
        @keyframes meridian-skeleton {
          0% { background-position: 200% 0; }
          100% { background-position: -200% 0; }
        }
        @media (prefers-reduced-motion: reduce) {
          [aria-busy="true"] { animation: none !important; }
        }
      `}</style>
      {label ? <span>{label}</span> : null}
    </div>
  );
}
